"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoundedInput = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const svg_1 = require("../../svg/");
const flex_1 = require("../../layout/flex");
const styled_1 = __importDefault(require("../../../styles/styled"));
const app_text_1 = __importDefault(require("../../typography/app_text"));
const RoundedInput = (_a) => {
    var { name, error, placeholder, label, hideLabel = !label, disabled } = _a, rest = __rest(_a, ["name", "error", "placeholder", "label", "hideLabel", "disabled"]);
    const [showInput, setShowInput] = (0, react_1.useState)(name !== 'password');
    return ((0, jsx_runtime_1.jsxs)(RoundedDiv, Object.assign({ error: !!error, disabled: disabled }, { children: [(0, jsx_runtime_1.jsxs)(flex_1.Row, { children: [(0, jsx_runtime_1.jsx)(Input, Object.assign({}, rest, { id: name, disabled: disabled, type: showInput ? 'text' : 'password', placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : ' ' })), !hideLabel && (0, jsx_runtime_1.jsx)(InputLabel, Object.assign({ htmlFor: name }, { children: label })), name === 'password' && ((0, jsx_runtime_1.jsx)(svg_1.PasswordEyeIcon, { onClick: () => setShowInput(!showInput), height: "25%", width: "50px", style: {
                            position: 'absolute',
                            right: 0,
                            top: '33%',
                            stroke: showInput ? undefined : 'gray',
                            transition: 'stroke 0.2s',
                        } }))] }), (0, jsx_runtime_1.jsx)(InputError, { children: error })] })));
};
exports.RoundedInput = RoundedInput;
const floatingLabel = {
    'label, input': {
        transition: 'all 0.2s',
    },
    // Regular (non-floating) styles
    'input:placeholder-shown + label': {
        cursor: 'text',
        whiteSpace: 'nowrap',
        transformOrigin: 'left bottom',
        transform: 'translate(0, 0) scale(1)',
    },
    // Floating styles
    'input:not(:placeholder-shown) + label': {
        transform: 'translate(0, 1.125rem) scale(1.5)',
        cursor: 'pointer',
    },
    'input:focus + label': {
        transform: 'translate(0, 0) scale(1)',
        cursor: 'pointer',
    },
};
const RoundedDiv = styled_1.default.div(props => (Object.assign({ position: 'relative', display: 'flex', flex: 1, border: props.error ? '2px solid #ff0000' : '2px solid #2C2C2C', borderRadius: 2, padding: 5, margin: 5, flexDirection: 'column', transition: ['border 0.2s', 'background-color 0.2s'], backgroundColor: props.disabled ? props.theme.colors.grey10 : undefined }, floatingLabel)));
const Input = styled_1.default.input({
    flex: 1,
    border: 0,
    height: 50,
    outline: 'none',
}, ({ theme, disabled }) => ({
    background: theme.colors.white,
    fontFamily: theme.text.bodyFontFamily,
    fontSize: theme.text.size.medium,
    color: theme.colors.grey90,
    transition: 'background-color 0.2s',
    backgroundColor: disabled ? theme.colors.grey10 : undefined,
}));
const InputLabel = styled_1.default.label({
    position: 'absolute',
    textTransform: 'capitalize',
}, ({ theme }) => ({
    fontFamily: theme.text.headingFontFamily,
    fontSize: theme.text.size.small,
    color: theme.colors.grey30,
}));
const InputError = (0, styled_1.default)(app_text_1.default)({
    color: 'red',
    margin: 0,
    textTransform: 'capitalize',
});
//# sourceMappingURL=rounded_input.js.map